// ── ModerationOverview ✦ — top 6-tile strip on the admin panel ─
//
// The default landing surface. Clicking a tile jumps to the
// corresponding moderation panel. Tone is operational-calm —
// red reserved for genuine emergencies.
import React from 'react';
import {
  ShieldCheck, FilmStrip, ChatCircleDots, Heart, Bell, Envelope,
} from '@phosphor-icons/react';
import { BLUE, PURPLE, PINK, GOLD, DANGER, SAGE } from './palette';
import { MetricsTile } from './MetricsTile';

export const ModerationOverview = ({ overview, onJump }) => (
  <div
    data-testid="admin-overview"
    style={{ display: 'grid', gap: 10, gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))' }}
  >
    <MetricsTile label="Safeguarding open" value={overview.safeguarding_open ?? '—'}
      icon={ShieldCheck} accent={DANGER} testid="admin-card-safeguarding"
      onClick={() => onJump('safeguarding')} />
    <MetricsTile label="Video open" value={overview.video_open ?? '—'}
      icon={FilmStrip} accent={GOLD} testid="admin-card-video"
      onClick={() => onJump('video')} />
    <MetricsTile label="Messaging · 7d" value={overview.messaging_reports_week ?? '—'}
      icon={ChatCircleDots} accent={BLUE} testid="admin-card-messaging"
      onClick={() => onJump('messaging')} />
    <MetricsTile label="Directed invites · 7d" value={overview.directed_invites_week ?? '—'}
      icon={Heart} accent={PINK} testid="admin-card-directed"
      onClick={() => onJump('directed')} />
    <MetricsTile label="Push · today" value={overview.push_today ?? '—'}
      icon={Bell} accent={PURPLE} testid="admin-card-push"
      onClick={() => onJump('push')} />
    <MetricsTile label="Digest · today" value={overview.digest_today ?? '—'}
      icon={Envelope} accent={SAGE} testid="admin-card-digest"
      onClick={() => onJump('digest')} />
  </div>
);
